
$(function ($) {
$(window).on('load',function() {
equalheight('h3.card-information__text.h5');
});


$(window).on('resize',function() {
equalheight('h3.card-information__text.h5');
});
});


$('.home_wrapper').slick({
  infinite: true,
  slidesToShow: 1,
  dots:true,
  arrows:false,
  slidesToScroll: 1
});


$('.fetured_collection .product-grid').slick({
  infinite: true,
  slidesToShow: 4,
  dots:false,
  arrows:true,
  slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

jQuery(".faq_box h5").first().addClass("show");
jQuery(".faq_box  h5").click(function(){if(jQuery(this).hasClass("show"))
{jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
                                        else
                                        {jQuery(".faq_box h5").removeClass("show");jQuery(".faq_box h5").next().slideUp();jQuery(this).addClass("show");jQuery(this).next().slideDown();}});
if($(window).width() <= '989'){
	$('.services_inner').slick({
      infinite: true,
      slidesToShow: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      dots:false,
      arrows:false,
      slidesToScroll: 1
	});
}


if($(window).width() <= '1199'){
	$('.branad_inner').slick({
      infinite: true,
      slidesToShow: 4,
      autoplay: true,
      autoplaySpeed: 2000,
      dots:false,
      arrows:false,
      slidesToScroll: 1,
         responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
	});
}


jQuery(".footer-block__heading").click(function(){
	  if($(window).width() <= '749'){
	  if(jQuery(this).hasClass("show"))
			{
	          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
	  else
			{
	          jQuery(".footer-block__heading").removeClass("show");
	          jQuery(".footer-block__heading").next().slideUp();
	          jQuery(this).addClass("show");jQuery(this).next().slideDown();
	        }
	    }
	});



$('.recommendations-slider').slick({
  infinite: true,
  dots:false,
  arrows:true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows:true
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows:true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:true
      }
    }
  ]
});


/* Shop slider */ 

$('.shop-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: '.shop-slider-nav'
});
$('.shop-slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.shop-slider',
  dots: false,
  arrows: true,
  infinite: false,
  focusOnSelect: true,
  vertical:true,
  verticalSwiping:false,
  responsive: [

    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },     
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        vertical:false
        // horizontal:true,


      }
    },
    { 
      breakpoint:768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical:false,
        verticalSwiping:false
      }
    },
    { 
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        vertical:false
      }
    }
   

  ]
});

/* Shop slider end*/ 

class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.init()

    // Add resize observer to update container height
    const resizeObserver = new ResizeObserver(entries => this.update());
    resizeObserver.observe(this);

    // Bind event listeners
    this.navItems.forEach(item => item.addEventListener('click', this.onNavItemClick.bind(this)))
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    // Listen for variant selection change to make current variant image active
    window.addEventListener('message', this.onVariantChange.bind(this))
  }

  init() {
    // Set up our DOM element variables
    this.imagesContainer = this.querySelector('.product-gallery__images');
    this.navItems = this.querySelectorAll('.product-gallery__nav-item');
    this.images = this.querySelectorAll('.product-gallery__image');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    // If there is no active images set the first image to active
    if (this.findCurrentIndex() === -1) {
      this.setCurrentImage(this.images[0])
    }
  }

  onVariantChange(event) {
    if (!event.data || event.data.type !== 'variant_changed') return 
    const currentImage = Array.from(this.images).find(item => item.dataset.mediaId == event.data.variant.featured_media.id)
    if (currentImage) {
      this.setCurrentImage(currentImage)
    }
  }

  onNavItemClick(event) {
    const mediaId = event.target.closest('li').dataset.mediaId
    this.images.forEach(item => item.classList.remove('product-gallery__image--active'))
    this.setCurrentImage(Array.from(this.images).find(item => item.dataset.mediaId === mediaId))
  }

  update() {
    this.style.height = `${this.imagesContainer.offsetHeight}px`
    this.prevButton.removeAttribute('disabled')
    this.nextButton.removeAttribute('disabled')
    if (this.findCurrentIndex() === 0) this.prevButton.setAttribute('disabled', true)
    if (this.findCurrentIndex() === this.images.length - 1) this.nextButton.setAttribute('disabled', true)
  }

  setCurrentImage(elem) {
    this.images.forEach(item => item.classList.remove('product-gallery__image--active'))
    elem.classList.add('product-gallery__image--active')
    this.update()
  }

  findCurrentIndex() {
    return Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active'))
  }

  onButtonClick(event) {
    event.preventDefault();
    let index = this.findCurrentIndex()
    if (event.currentTarget.name === 'next') {
      index++
    } else {
      index--
    }
    this.setCurrentImage(this.images[index])
  }
}

customElements.define('product-gallery', ProductGallery);

/*---------------- Easy Responsive Tab ------------------*/
if ($('#parentHorizontalTab').length) {
  $('#parentHorizontalTab').easyResponsiveTabs({
    type: 'default', //Types: default, vertical, accordion
    width: 'auto', //auto or any width like 600px
    fit: true, // 100% fit in a container
    tabidentify: 'hor_1', // The tab groups identifier
    activate: function(event) { // Callback function if tab is switched
      var $tab = $(this);
      var $info = $('#nested-tabInfo');
      var $name = $('span', $info);
      $name.text($tab.text());
      $info.show();
    }
  });
}
/*---------------- Easy Responsive Tab ------------------*/


$(function(){

// bind change event to select

$('#dynamic_select').on('change', function () {

var url = $(this).val(); // get selected value

if (url) { // require a URL

window.location = url; // redirect

} return false;

});

});